module.exports = __webpack_public_path__ + "img/Guardar Icono.e7b348b8.svg";